import React from 'react';
import PropTypes from 'prop-types';

const StoreTag = ({ store, isInPostStoreLocatorRebrandEnabled }) => {
    const isStore = store === 'PaypointStore';
    const isInPostShop = isStore && isInPostStoreLocatorRebrandEnabled;

    return (
        <div
            className={`store-tag${!isStore ? " -locker" : ""}${isInPostShop ? " -inpost-shop" : ""}`}
        >
            {isStore ? (isInPostShop ? 'Shop' : 'Store') : 'InPost Locker'}
        </div>
    );
};

StoreTag.propTypes = {
    store: PropTypes.oneOf(['PaypointStore', 'InPostLocker']).isRequired,
    isInPostStoreLocatorRebrandEnabled: PropTypes.bool,
};

export default StoreTag;